export enum Product {
  EzyMedical = 'ezy-medical',
  iMedicalCard = 'iMedical-card-elite',
  EasyHealth = 'easy-health',
}

export enum ProductEnums {
  // i-MedicalCard Elite Takaful
  IMedicalCardEliteTakafulEn = 'iMedicalCardEliteTakaful-en',
  IMedicalCardEliteTakafulMy = 'iMedicalCardEliteTakaful-my',
  IMedicalCardEliteTakafulEnMobile = 'iMedicalCardEliteTakaful-en-Mobile',
  IMedicalCardEliteTakafulMyMobile = 'iMedicalCardEliteTakaful-my-Mobile',

  // EzyMedical Insurance
  EzyMedicalInsuranceEn = 'EzyMedical-en',
  EzyMedicalInsuranceMy = 'EzyMedical-my',
  EzyMedicalInsuranceEnMobile = 'EzyMedical-en-Mobile',
  EzyMedicalInsuranceMyMobile = 'EzyMedical-my-Mobile',
}
